<template>
  <van-popup class="account-language-popup" v-model="visible" round position="bottom">
    <van-picker :key="visible + $i18n.locale" :default-index="Math.max(0, columns.findIndex(item => item.type === $i18n.locale))" show-toolbar :columns="columns" @cancel="visible = false" @confirm="languageConfirm" :confirm-button-text="$t('common.confirmText')" :cancel-button-text="$t('common.cancelText')" />
  </van-popup>
</template>

<script>
import { languages } from "@/i18n/languages";
export default {
  name: "languageSettings",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      columns: languages
    }
  },
  computed: {
    visible: {
      get () {
        return this.show;
      },
      set (val) {
        if (!val) this.$emit('close');
      }
    }
  },
  methods: {
    // 语言切换
    languageConfirm (col) {
      this.$store.commit('SET_LANGUAGE', this.columns.find(item => item.type == col.type));
      this.$i18n.locale = col.type;
      this.$emit('close');
    },
  }
};
</script>

<style scoped lang="scss">

</style>
